import { type FunctionComponent } from 'react';
import CirclePerson from 'dibs-icons/exports/legacy/CirclePerson';
import CircleProfessional from 'dibs-icons/exports/legacy/CircleProfessional';
import classnames from 'classnames';

import dibsCss from 'dibs-css';
import style from './MatchmakerIcon.scss';

type MatchmakerIconProps = {
    wrapperClass?: string;
    iconWrapperClass?: string;
    personClass?: string;
    professionalClass?: string;
    dividerClass?: string;
};

export const MatchmakerIcon: FunctionComponent<MatchmakerIconProps> = props => {
    const iconWrapperClass = classnames(style.iconWrapper, props.iconWrapperClass);

    return (
        <div className={classnames(dibsCss.inlineBlock, dibsCss.alignMiddle)}>
            <div
                className={classnames(
                    dibsCss.flex,
                    dibsCss.itemsCenter,
                    dibsCss.w60px,
                    props.wrapperClass
                )}
            >
                <span className={iconWrapperClass}>
                    <CirclePerson
                        className={classnames(
                            dibsCss.block,
                            dibsCss.fillBuyersecondary,
                            props.personClass
                        )}
                    />
                </span>
                <span className={classnames(style.divider, props.dividerClass)} />
                <span className={iconWrapperClass}>
                    <CircleProfessional
                        className={classnames(
                            dibsCss.block,
                            dibsCss.fillTradeprimary,
                            props.professionalClass
                        )}
                    />
                </span>
            </div>
        </div>
    );
};
